import React, { useState } from 'react';
import styled from 'styled-components';
import { faReply } from '@fortawesome/free-solid-svg-icons';
import siconfiPages from 'config/siconfi.config';
import AcessoSTNService from 'services/AcessoSTNService';
import { toast } from 'react-toastify';
import KskButton from 'ksk/styledComponents/components/KskButton/KskButton';
import KskToast from 'ksk/styledComponents/components/KskToast/KskToast';

const authGovBrLog = (step, payload) => {
  console.log(`[auth gov.br] ${step}`, payload ?? '');
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
  min-height: 100vh;
  background: #0C326F;
`;

const LoginContainer = styled.div`
  background: #fff;
  color: #1351b4;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 2em;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const MainTitle = styled.h1`
  font-size: 2rem;
  color: #000;
  margin-bottom: 0.5rem;
  font-weight: 500;
  text-align: center;
`;

const Subtitle = styled.h4`
  font-size: 1rem;
  color: #000;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid #d8d8d8;
`;

function CredenciaisAcessoSTN() {
  const [loading, setLoading] = useState(false);

  const handleLoginGovBr = async () => {
    try {
      authGovBrLog('Clique em "Acessar com Gov.br"', {
        currentUrl: window.location.href,
      });
      setLoading(true);
      const response = await AcessoSTNService.obterUrlAcessoGovBr();

      authGovBrLog('Resposta ao gerar URL de acesso Gov.br', {
        status: response?.status,
        hasRedirectUrl: !!response?.data,
        redirectUrl: response?.data,
      });

      if (response?.data) {
        authGovBrLog('Redirecionando navegador para Gov.br', {
          redirectUrl: response.data,
        });
        window.location.href = response.data;
      }
    } catch (error) {
      authGovBrLog('Falha ao obter URL de acesso Gov.br', {
        message: error?.message,
        status: error?.response?.status,
        data: error?.response?.data,
      });
      console.error('Erro ao obter URL de acesso Gov.br:', error);
      toast.error(<KskToast error httpError={error} mainMessage="Erro ao obter URL de acesso Gov.br" />);
    } finally {
      authGovBrLog('Finalizando tentativa de redirecionamento para Gov.br', {
        loadingBeforeReset: true,
      });
      setLoading(false);
    }
  };

  const handleSiconfiPai = () => {
    authGovBrLog('Clique em "Acessar com Siconfi Pai"', {
      targetUrl: siconfiPages.LOGIN_AREA_RESTRITA,
    });
    window.location.href = siconfiPages.LOGIN_AREA_RESTRITA;
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <PageContainer>
      <LoginContainer>
        {/* <Logo 
          src="/assets/static/login/logo_opc.png" 
          alt="Logotipo do Siconfi" 
        /> */}
        <MainTitle>Acesso ao Sadipem</MainTitle>
        <Subtitle>Use este caminho para criar uma conta, acessar o sistema, solicitar um vínculo ou recuperar o acesso.</Subtitle>
        
        <ButtonContainer>
          <button className="br-sign-in primary" type="button" onClick={handleLoginGovBr} disabled={loading}>
            <span className="d-sm-inline">{loading ? 'Carregando...' : 'Acessar com Gov.br'}</span>
          </button>

          <button className="br-sign-in secondary" type="button" onClick={handleSiconfiPai}>
            <span>Acessar com Siconfi Pai</span>
          </button>
          <Divider />
          <KskButton
            icon={faReply}
            label="Voltar"
            onClick={handleBack}
            style={{ width: '100%' }}
            containerProps={{ width: '100%' }}
          />
        </ButtonContainer>
      </LoginContainer>
    </PageContainer>
  );
}

export default CredenciaisAcessoSTN;
